import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { apiMe } from '../api/authApi';

const AuthContext = createContext(null);

const SESSION_KEY = 'af_token'; // sessionStorage key — cleared on browser close

export function AuthProvider({ children }) {
  const [token, setToken]   = useState(() => sessionStorage.getItem(SESSION_KEY));
  const [user,  setUser]    = useState(null);
  const [ready, setReady]   = useState(false); // true once we've checked the session

  // On mount: if a token exists in sessionStorage, validate it with the server
  useEffect(() => {
    if (!token) { setReady(true); return; }

    apiMe(token)
      .then(({ user }) => setUser(user))
      .catch(() => {
        sessionStorage.removeItem(SESSION_KEY);
        setToken(null);
      })
      .finally(() => setReady(true));
  }, []); // run once on mount only

  const login = useCallback((newToken, newUser) => {
    sessionStorage.setItem(SESSION_KEY, newToken);
    setToken(newToken);
    setUser(newUser);
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem(SESSION_KEY);
    setToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ token, user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
